/**
 * Add to list icon. Uses `currentColor` for stroke.
 */
export function AddToList({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path d="M6 10H18" />
      <path d="M6 6H18" />
      <path d="M6 14H10" />
      <path d="M14 16H18" />
      <path d="M16 14L16 18" />
      <path d="M6 18H10" />
    </svg>
  )
}